import { Injectable, NgZone } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, EMPTY, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Auth } from 'aws-amplify';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private zone: NgZone) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return new Observable(observer => {
      // Toda a cadeia roda dentro da Angular zone para disparar change detection automaticamente
      this.zone.run(() => {
        from(Auth.currentSession()).pipe(
          catchError(sessionErr => {
            console.error('AuthInterceptor: sem sessão ativa, redirecionando para login.', sessionErr);
            this.router.navigate(['/auth/login']);
            return EMPTY;
          }),
          switchMap((session: any) => {
            const token = session.getIdToken().getJwtToken();
            const authReq = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
            return next.handle(authReq).pipe(
              catchError((httpErr: HttpErrorResponse) => {
                if (httpErr.status === 401) {
                  console.error('AuthInterceptor: token rejeitado pelo servidor (401), redirecionando para login.', httpErr);
                  this.router.navigate(['/auth/login']);
                  return EMPTY;
                }
                return throwError(() => httpErr);
              })
            );
          })
        ).subscribe(observer);
      });
    });
  }
}